import React, { useEffect, useState, useCallback } from "react";
import "devextreme/dist/css/dx.light.css";
import "./DataReceipt.scss";
import CustomStore from "devextreme/data/custom_store";
import ReactJson from "react18-json-view";
import ScrollView from "devextreme-react/scroll-view";
import { Popup } from "devextreme-react/popup";
import { Button } from "devextreme-react/button";
import { saveAs } from "file-saver";
import Notification from "../Notification/Notification";
import DataReceiptEnvDetail from "../EnvDetails/EnvDetails";
import { DataReceiptFileTypeDataGrid, DataReceiptsGrid } from "../DataGrid/DataGrid";
import { downloadSvg, dataReceiptIConSvg } from "../../Assets/SVGs/dataReceiptSVGs";
import { environmentPropTypes } from "../../Constants/propTypes";
import { useUser } from "../../contexts/UserContext";

const DataReceipt = (envData) => {
  const { backend } = useUser();
  const [dataReceiptTypeId, setDataReceiptTypeId] = useState();
  const [jsonViewer, setJsonViewer] = useState(false);
  const [jsonData, setJsonData] = useState();
  const [jsonDataFileName, setJsonDataFileName] = useState();
  const [isLoader, setIsLoader] = useState(false);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [pageNumber, setPageNumber] = useState();
  const [pageChangeTrue, setPageChangeTrue] = useState(false);
  const [defaultPageSize, setDefaultPageSize] = useState(10);
  const [defaultPageNumber, setDefaultPageNumber] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [fileType, setFileType] = useState();
  const [fileCreatedDate, setFileCreatedDate] = useState();
  const [dataReceiptsCount, setDataReceiptsCount] = useState();
  const [customStore, setCustomStore] = useState();
  const [supportedFileTypes, setSupportedFileTypes] = useState();

  const sendRequest = useCallback(
    // eslint-disable-next-line consistent-return
    (type) => {
      if (type === "load") {
        return backend
          .callDataRecieptFileTypesForDataReceipts(
            envData.envData.id,
            defaultPageNumber,
            defaultPageSize
          )
          .then((res) => res)
          .catch((err) => {
            console.log(err);
          });
      }
    },
    [backend, defaultPageNumber, defaultPageSize, envData.envData.id]
  );

  useEffect(() => {
    backend
      .callDataReceiptFileTypes()
      .then((res) => {
        const fileTypesEnv = [];
        envData.envData.supportedDataReceiptTypes.forEach((ele) => {
          const env = res.data.find((x) => x.id === ele);
          fileTypesEnv.push(env.fileType);
        });
        setSupportedFileTypes(fileTypesEnv.join(", "));
      })
      .then(() => {
        setCustomStore(
          new CustomStore({
            load: async () => sendRequest("load"),
          })
        );
      })
      .catch((error) => {
        console.error(error);
      });
  }, [backend, envData.envData.supportedDataReceiptTypes, sendRequest]);

  const selectedFileType = useCallback((e) => {
    setDataReceiptsCount(e.data.totalCount);
    setFileType(e.data.dataReceiptType);
    setDataReceiptTypeId(e.data.dataReceiptTypeId);
  }, []);

  const sendRequestforList = useCallback(
    // eslint-disable-next-line consistent-return
    (type) => {
      if (type === "load") {
        return backend.callDataRecieptListByType(
          envData.envData.id,
          dataReceiptTypeId,
          pageNumber,
          defaultPageSize
        );
      }
    },
    [backend, dataReceiptTypeId, defaultPageSize, envData.envData.id, pageNumber]
  );

  const setTotalCount = useCallback(() => {
    setDefaultPageNumber(1);
    setDefaultPageSize(10);
    return backend.callDataRecieptListByType(
      envData.envData.id,
      dataReceiptTypeId,
      defaultPageNumber,
      defaultPageSize
    );
  }, [
    backend,
    dataReceiptTypeId,
    defaultPageNumber,
    defaultPageSize,
    envData.envData.id,
  ]);

  const togglePopup = useCallback(() => {
    setIsPopupVisible(!isPopupVisible);
    setJsonViewer(false);
  }, [isPopupVisible]);

  const pageChanged = (page) => {
    setCurrentPage(page);
    setPageChangeTrue(true);
    setPageNumber(page);
  };

  const downloadJsonData = useCallback(() => {
    const contentType = { type: "application/json" };
    const stringifyJSONData = JSON.stringify(jsonData);
    const blob = new Blob([stringifyJSONData], contentType);
    saveAs(blob, jsonDataFileName);
  }, [jsonData, jsonDataFileName]);
  const viewDataReceiptContent = useCallback(
    (dataReceipt) => {
      setFileCreatedDate(dataReceipt.createdOn);
      if (dataReceipt.fileName.includes(".json")) {
        setIsLoader(true);
        const dataRecieptid = dataReceipt.id;

        backend
          .callDataRecieptSasById(dataRecieptid)
          .then((res) => {
            if (!res.succeeded) {
              Notification(res.message, "error");
            } else {
              fetch(res.data.sasUri)
                .then((Response) => Response.json())
                .then((responseJson) => {
                  setJsonViewer(true);
                  setJsonData(responseJson);
                  setIsPopupVisible(true);
                  setJsonDataFileName(dataReceipt.fileName);
                });
              setIsLoader(false);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    [backend]
  );

  const viewJSONData = useCallback(
    () => (
      <div className="jsonViewer">
        <Popup
          visible={isPopupVisible}
          hideOnOutsideClick={true}
          onHiding={togglePopup}
          showTitle={true}
          title="Data receipt"
          position="center"
          maxHeight={500}
          maxWidth={764}
        >
          <div className="receiptDetails">
            <span>{fileType}</span> | <span>{jsonDataFileName}</span> |{" "}
            <span>
              &nbsp;
              {fileCreatedDate?.substring(8, 10)}&nbsp;
              {new Date(fileCreatedDate?.substring(5, 7)).toLocaleString("en-us", {
                month: "short",
              })}
              &nbsp;
              {fileCreatedDate?.substring(0, 4)}
            </span>
            &nbsp; | <span>{fileCreatedDate?.substring(11, 16)}</span>
          </div>
          <hr className="receipt_headingLine" />
          <div className="json-view-container">
            <ScrollView height="300" direction="vertical">
              <ReactJson
                src={jsonData}
                theme="default"
                enableClipboard={false}
                editable={false}
                onEdit={() => {}}
                onDelete={() => {}}
                onAdd={() => {}}
                collapseStringsAfterLength={30}
                collapsed={false}
              />
            </ScrollView>
          </div>
          <hr className="footer_Receipt" />
          <div className="downloadButton">
            <Button text="Download" className="download" onClick={downloadJsonData}>
              {downloadSvg}
              Download
            </Button>
          </div>
        </Popup>
      </div>
    ),
    [
      downloadJsonData,
      fileCreatedDate,
      fileType,
      isPopupVisible,
      jsonData,
      jsonDataFileName,
      togglePopup,
    ]
  );

  const downloadDataRecieptSasUri = useCallback(
    (data) => {
      setIsLoader(true);
      backend
        .callDataRecieptSasById(data.id)
        .then((res) => {
          if (res.succeeded) {
            window.open(res.data.sasUri);
          } else {
            Notification(res.message, "error");
          }
        })
        .catch((err) => {
          Notification(err.response.data.message, "error");
        });
    },
    [backend]
  );

  const viewDataReceiptFiles = useCallback(
    () => (
      <DataReceiptsGrid
        pageChangeTrue={pageChangeTrue}
        sendRequestforList={sendRequestforList}
        setTotalCount={setTotalCount}
        viewDataReceiptContent={viewDataReceiptContent}
        currentPage={currentPage}
        dataReceiptsCount={dataReceiptsCount}
        downloadDataRecieptSasUri={downloadDataRecieptSasUri}
        pageChanged={pageChanged}
      />
    ),
    [
      currentPage,
      dataReceiptsCount,
      downloadDataRecieptSasUri,
      pageChangeTrue,
      sendRequestforList,
      setTotalCount,
      viewDataReceiptContent,
    ]
  );

  const viewDataReceipts = useCallback(
    () => (
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <>{jsonViewer && !isLoader ? viewJSONData() : viewDataReceiptFiles()}</>
    ),
    [isLoader, jsonViewer, viewDataReceiptFiles, viewJSONData]
  );

  const expanded = useCallback((e) => {
    setCurrentPage(1);
    setPageChangeTrue(false);
    setPageNumber();
    if (e.component.shouldSkipNext) {
      e.component.shouldSkipNext = false;
      return;
    }
    e.component.selectRows([e.key], false);
    e.component.collapseAll(-1);
    e.component.shouldSkipNext = true;
    e.component.expandRow(e.key);
  }, []);

  const copyToClipboard = useCallback(() => {
    const copyText = envData.envData.appRegistrationId;
    navigator.clipboard.writeText(copyText);
    Notification("Client ID Copied Successfully", "success");
  }, [envData.envData.appRegistrationId]);

  const viewDataReceiptData = () => (
    <div id="datareceipt-div-viewdata">
      <div />
      <div className="env-Details d-flex">
        <DataReceiptEnvDetail
          envDataName={envData?.envData?.name}
          envDataAccessUrl={envData?.envData?.accessUrl}
          envDataActive={envData?.envData?.active}
          envDataCreatedOn={envData?.envData?.createdOn}
          envDataLastUpdatedOn={envData?.envData?.lastUpdatedOn}
          supportedFileTypes={supportedFileTypes}
          envDataAppRegistrationId={envData?.envData?.appRegistrationId}
          copyToClipboard={copyToClipboard}
        />

        <div className="dataRceipttile">
          <div className="dataReceiptgrid">
            <div className="dataReceiptgridcontent">
              <div className="d-flex flex-column">
                <div className="data-Receipts">
                  <span className="data-ReceiptSvg">{dataReceiptIConSvg}</span>
                  <span className="data-ReceiptTag">Data receipts</span>
                </div>
                <div className="env_tag">
                  &nbsp;
                  <i>View data received from {envData?.envData?.name}</i>
                </div>
                <DataReceiptFileTypeDataGrid
                  customStore={customStore}
                  selectedFileType={selectedFileType}
                  expanded={expanded}
                  viewDataReceipts={viewDataReceipts}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  return viewDataReceiptData();
};
DataReceipt.propTypes = {
  envData: environmentPropTypes.isRequired,
};
export default DataReceipt;
